import React, { useState, useEffect, useRef, useCallback } from 'react';
import './BlockedSubscription.css';

const slides = [
  {
    icon: '🤝',
    title: 'Share Your Referral Link',
    text: 'Your unique referral link is in the app and your first login email. Share it to help us reach more players — and earn credits.',
  },
  {
    icon: '🎬',
    title: 'Post Awesome Videos',
    text: 'Upload your matches and practice sessions. Great shots get rewarded with bonus credits — and every video helps our AI improve.',
  },
];

const BlockedSubscription = () => {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const [dragging, setDragging] = useState(false);
  const startX = useRef(0);
  const timerRef = useRef(null);

  const goTo = useCallback((index) => {
    setActive((index + slides.length) % slides.length);
  }, []);

  // Auto-slide
  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timerRef.current);
  }, [paused]);

  // Touch / mouse drag
  const onDragStart = (e) => {
    setPaused(true);
    setDragging(true);
    startX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };

  const onDragEnd = (e) => {
    if (!dragging) return;
    setDragging(false);
    const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const diff = endX - startX.current;
    if (Math.abs(diff) > 40) {
      goTo(active + (diff < 0 ? 1 : -1));
    }
    // Resume auto-slide after manual interaction
    setTimeout(() => setPaused(false), 6000);
  };

  return (
    <div className="blocked-page">
      <div className="blocked-card">

        <div className="blocked-header">
          <span className="blocked-icon">🎾</span>
          <h1 className="blocked-title">INTER TENNIS</h1>
        </div>

        <h2 className="blocked-subtitle fade-in">No Paid Subscriptions</h2>

        <p className="blocked-text fade-in-delay">
          INTER TENNIS does not offer paid subscriptions or credit purchases — and that's intentional. We believe every player deserves access to AI-powered analytics, free of charge.
        </p>

        <div className="blocked-divider"></div>

        <h3 className="slider-heading fade-in-delay">Two Ways to Get Credits</h3>

        {/* Slider */}
        <div
          className="slider"
          onTouchStart={onDragStart}
          onTouchEnd={onDragEnd}
          onMouseDown={onDragStart}
          onMouseUp={onDragEnd}
          onMouseLeave={() => { if (dragging) onDragEnd({ clientX: 0, changedTouches: null }); }}
        >
          <div
            className="slider-track"
            style={{ transform: `translateX(-${active * 100}%)` }}
          >
            {slides.map((slide, i) => (
              <div className="slide" key={i}>
                <div className="slide-panel">
                  <span className="slide-icon">{slide.icon}</span>
                  <h4 className="slide-title">{slide.title}</h4>
                  <p className="slide-text">{slide.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="slider-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`slider-dot${i === active ? ' active' : ''}`}
                onClick={() => { goTo(i); setPaused(true); setTimeout(() => setPaused(false), 6000); }}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Video */}
        <div className="blocked-video fade-in-delay">
          <video
            autoPlay
            loop
            muted
            playsInline
            src="https://stock.inter.tennis/referral/share_referral_credits.mp4"
          />
        </div>

        <p className="blocked-closing fade-in-delay">
          Thank you for helping us bring this technology to the tennis community worldwide.
        </p>

        <div className="blocked-footer">
          <p>Smashingly yours,</p>
          <p className="blocked-team">INTER TENNIS</p>
        </div>
      </div>
    </div>
  );
};

export default BlockedSubscription;
